import { axiosInstance } from './axios-instance';
import { PAGE_SIZE } from '../magic-values';
import type { PaginatedResult, PaginationDto } from '../types/common';
import type { AccountDoc } from '../types/account';

export interface AccountsFilters {
  filterBy?: string;
}

export class AccountService {
  static async getAccounts(
    filters?: AccountsFilters,
    pagination?: PaginationDto,
  ): Promise<PaginatedResult<AccountDoc>> {
    const res = await axiosInstance.get<PaginatedResult<AccountDoc>>('/admin/accounts', {
      params: { pageSize: PAGE_SIZE, ...pagination, ...filters },
    });
    return res.data;
  }

  static async getAccount(id: string): Promise<AccountDoc> {
    const res = await axiosInstance.get<AccountDoc>(`/admin/accounts/${id}`);
    return res.data;
  }
}
